import React, { useContext } from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { WindowSizeContext } from '/src/App';
import './style.css';

const ClimateIcon = ({ risk, riskLevel, index }) => {
    const { deviceType } = useContext(WindowSizeContext);

    const riskLevelLookup = {
        1: "high",
        2: "medium",
        3: "low",
        4: "inactive"
    };

    const riskLevelClass = riskLevelLookup[riskLevel] || "inactive";

    return (
        <div
            className={`climate-icon-container ${riskLevelClass} ${deviceType}`}
            data-risk-index={index}
        >
            <img
                src={CreateCloudfrontUrl(risk.icon_light)}
                alt="Climate Risk Icon"
                className="climate-icon-image"
            />
        </div>
    );
};

export default ClimateIcon;
